import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetCSAlertConfigurationList } from "../Responses/GetCSAlertConfigurationList";

export async function getCSAlertConfigurationList(data) {
	let response = await getAPIResponse("/v1/cs/alert-configuration-list", data);
	if (response === null) {
		return null;
	}
	let getProposalProjectList = GetCSAlertConfigurationList.createFromResponseData(response);
	return getProposalProjectList;
}